'use client'

import { toast } from '@/lib/toast'
import { useAddressForm } from '@/lib/commerce/hooks'
import { DarkAddressFormFields, DarkAddressModal } from './AddressList'

interface AddressEditProps {
  open: boolean
  setOpen: (open: boolean) => void
  address: any
  addressField: any
  vendor?: any
  updateAddress: (id: string, body: any) => Promise<boolean>
  submitting: boolean
}

export default function AddressEdit({ open, setOpen, address, addressField, vendor, updateAddress, submitting }: AddressEditProps) {
  const form = useAddressForm({ addressField, vendor, initial: address })

  const handleSave = async () => {
    const v = form.validate()
    if (!v.ok) return toast.error(v.error)
    const ok = await updateAddress(address.id, form.compose())
    if (ok) setOpen(false)
  }

  return (
    <DarkAddressModal
      open={open}
      onClose={() => setOpen(false)}
      title="Хаяг засах"
      onSave={handleSave}
      submitting={submitting}
    >
      <DarkAddressFormFields form={form} />
    </DarkAddressModal>
  )
}
